import { isKnownSublocation, sublocationLabel } from '@ups/tool-tracker';

/** What the web sub-location control shows and whether it warns, for the value it holds. */
export interface SublocationControlState {
  /** The plain string the control holds and the saved answer carries. */
  text: string;
  /** The value names no listed sub-location. Warns, never blocks the save. */
  unknown: boolean;
}

/**
 * WI 34981: a saved answer is a plain string ("bench by door"), but a default value or a
 * NativeScript-shaped pick can be a `{ location }` record. Both become the same text, so old
 * and new rows display alike. With no list loaded there is nothing to compare against, so
 * nothing is flagged.
 */
export function sublocationControlState(
  names: Array<string>,
  value: unknown
): SublocationControlState {
  const text = sublocationLabel(value);
  return {
    text,
    unknown: names.length > 0 && !isKnownSublocation(names, text),
  };
}
